import React, { Component } from 'react';
import BookerTime from './BookerTime.container';
import FormInfo  from 'js/Containers/FormInfo.container';
//import {FormSubscribe} from 'js/Containers/FormSubscribe.containers';
import {lang} from 'js/Core/lang';
class TimelineStep extends Component {
    constructor(props){
        super(props);
    }    
    render() {
        let {selectedProducts, steps, handleChangeSubscribe, backToProduct, removeProduct, shopName} = this.props;
        return (
            <div id="mw_wp_form_mw-wp-form-38" className={`steps${steps.currentStep === 2 ? ' active' : ''}`}>
                <div className="txt-product-selected label-header" id="list-products-selected">{lang.txt.label_header_menu_selected}</div>	
                <table className="list-products list-products-show">
                    <tbody>
                        {
                            selectedProducts.map((e, i) => {
                                let item = this.props.products.find(ev => ev.id === e);
                                return (
                                    <tr key={i}>
                                        <td className="name">
                                            <p>{item.productName}</p>
                                            <div className="short-desc">
                                            {
                                                item.shortDescription !== '' ? <div>{item.shortDescription}</div> : ''
                                            } 
                                            </div>
                                        </td>
                                        <td  className="price">
                                            <span>{lang.label.yen}{item.price.toLocaleString()}{item.priceType === 'CUSTOMIZE' && '～'}</span>
                                            <button className="btn-remove-product btn-type-1" onClick={event => removeProduct(e)}>{lang.label.lable_btn_remove_product}</button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>	
                <div className="button-back-products"><button className="btn-type-1" onClick={e => backToProduct()}>{lang.txt.label_add_more_product}</button></div>								                
                <BookerTime />
                <FormInfo sexProps ageProps/>
                {/* <FormSubscribe handleChangeSubscribe={handleChangeSubscribe} shopName={shopName}/>											 */}
            </div>
        );
    }
}

export default TimelineStep;